// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBy7sTN4zOekL34fWxKDsIi5pNrDAvFLWo",
  authDomain: "travelfirst-ddc83.firebaseapp.com",
  projectId: "travelfirst-ddc83",
  storageBucket: "travelfirst-ddc83.firebasestorage.app",
  messagingSenderId: "163505033657",
  appId: "1:163505033657:web:af82231807c16aae3d2668",
  measurementId: "G-1C3VMW884Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics };